"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _uiTheme = require("@kyruus/ui-theme");
var _styles = require("./styles");
var _BookableLocation = _interopRequireDefault(require("./BookableLocation"));
var _NonBookableLocation = _interopRequireDefault(require("./NonBookableLocation"));
const propTypes = {
  bookableLocations: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    name: _propTypes.string,
    street1: _propTypes.string,
    street2: _propTypes.string,
    suite: _propTypes.string,
    city: _propTypes.string,
    state: _propTypes.string,
    zip: _propTypes.string
  })).isRequired,
  nonBookableLocations: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: _propTypes.string,
    name: _propTypes.string,
    street1: _propTypes.string,
    street2: _propTypes.string,
    suite: _propTypes.string,
    city: _propTypes.string,
    state: _propTypes.string,
    zip: _propTypes.string
  })).isRequired,
  /**
   * @callback
   * @param {String} id
   */
  onSelect: _propTypes.func.isRequired,
  /**
   * @callback
   * @param {String} id
   */
  onMouseEnter: _propTypes.func.isRequired,
  /**
   * @callback
   * @param {String} id
   */
  onMouseLeave: _propTypes.func.isRequired,
  selectedLocationIds: (0, _propTypes.instanceOf)(_set.default).isRequired,
  activeLocationId: _propTypes.string
};
const makeNameFromLocation = () => {
  let index = 0;
  return (name, street1) => {
    index++;
    return name ? `${index}. ${name}` : `${index}. ${street1}`;
  };
};
const Locations = (0, _uiTheme.withTheme)(_ref => {
  let {
    bookableLocations,
    nonBookableLocations,
    onMouseEnter,
    onMouseLeave,
    selectedLocationIds,
    onSelect,
    theme,
    activeLocationId = '',
    locationId
  } = _ref;
  const formatLocName = makeNameFromLocation();
  const activeLocationStyle = {
    background: theme.color_button_flat_hover
  };
  const findSelectedIdInBookableLocations = (0, _find.default)(bookableLocations).call(bookableLocations, loc => loc.id.toString() === locationId);
  return /*#__PURE__*/_react.default.createElement(_styles.List, {
    "data-testid": "ProviderLocations__Locations",
    className: "ProviderLocationsList"
  }, (0, _map.default)(bookableLocations).call(bookableLocations, loc => {
    let isSelected, disabled;
    if (findSelectedIdInBookableLocations?.id) {
      isSelected = loc.id.toString() === locationId;
      disabled = isSelected;
    } else {
      isSelected = selectedLocationIds.has(loc.id);
      disabled = selectedLocationIds.size === 1 && isSelected;
    }
    return /*#__PURE__*/_react.default.createElement("li", {
      key: loc.id,
      onMouseEnter: () => onMouseEnter(loc.id),
      onMouseLeave: () => onMouseLeave(loc.id),
      style: loc.id === activeLocationId ? activeLocationStyle : {}
    }, /*#__PURE__*/_react.default.createElement(_BookableLocation.default, (0, _extends2.default)({
      disabled: disabled,
      isSelected: isSelected,
      onSelect: onSelect
    }, loc, {
      name: formatLocName(loc.name, loc.street1)
    })));
  }), (0, _map.default)(nonBookableLocations).call(nonBookableLocations, loc => /*#__PURE__*/_react.default.createElement("li", {
    key: loc.id,
    onMouseEnter: () => onMouseEnter(loc.id),
    onMouseLeave: () => onMouseLeave(loc.id),
    style: loc.id === activeLocationId ? activeLocationStyle : {}
  }, /*#__PURE__*/_react.default.createElement(_NonBookableLocation.default, (0, _extends2.default)({}, loc, {
    name: formatLocName(loc.name, loc.street1)
  })))));
});
Locations.defaultProps = {
  activeLocationId: ''
};
Locations.propTypes = propTypes;
var _default = exports.default = Locations;